import React from 'react';
import { Row, Col, Statistic, Card } from 'antd';
import {
  TeamOutlined,
  UserOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
} from '@ant-design/icons';

interface LeadStatisticsProps {
  statistics: {
    total_leads: number;
    public_pool_leads: number;
    my_leads: number;
    converted_leads: number;
    recycled_leads: number;
    conversion_rate: number;
    my_conversion_rate?: number;
  } | null;
  loading: boolean;
  activeTab?: string;
}

const LeadStatistics: React.FC<LeadStatisticsProps> = ({ statistics, loading, activeTab = 'my-leads' }) => {
  if (!statistics) return null;

  // 根据当前标签页决定显示哪个转化率
  const displayConversionRate = activeTab === 'my-leads' && statistics.my_conversion_rate !== undefined
    ? statistics.my_conversion_rate
    : statistics.conversion_rate;

  const conversionRateTitle = activeTab === 'my-leads' ? '我的转化率' : '整体转化率';

  return (
    <Row gutter={16} style={{ marginBottom: 16 }}>
      <Col span={6}>
        <Card loading={loading}>
          <Statistic
            title="总线索数"
            value={statistics.total_leads}
            prefix={<TeamOutlined />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card loading={loading}>
          <Statistic
            title="公海池"
            value={statistics.public_pool_leads}
            prefix={<UserOutlined />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card loading={loading}>
          <Statistic
            title="我的线索"
            value={statistics.my_leads}
            prefix={<UserOutlined />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card loading={loading}>
          <Statistic
            title={conversionRateTitle}
            value={displayConversionRate}
            precision={2}
            suffix="%"
            prefix={<CheckCircleOutlined />}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default LeadStatistics;
